import React from "react";
import colors from "../../utils/colors";
import Button from "../../components/ui/button";
import { useNavigate } from "react-router-dom";

const Transform = () => {
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-col justify-center items-center text-center px-4 sm:px-8 py-12 sm:py-16 md:py-20 lg:py-[6.25rem]"
      style={{ background: colors.lightGrey }}
    >
      <div
        className="mb-4 sm:mb-6 md:mb-[1.25rem] font-lexend text-2xl sm:text-3xl md:text-4xl lg:text-[2.5rem] font-semibold"
        style={{ color: colors.dark }}
      >
        Transform your medical practice with us
      </div>
      <div
        className="mb-6 sm:mb-8 md:mb-[2.5rem] font-lexend text-base sm:text-lg md:text-xl lg:text-[1.25rem] font-normal max-w-2xl"
        style={{ color: colors.dark }}
      >
        Create an account with us today and take a step towards more efficient
        healthcare
      </div>

      <Button
        text="Create an Account Now"
        theme="primary"
        className="w-full sm:w-auto px-6 sm:px-[2rem] py-3 sm:py-[1rem] rounded-md sm:rounded-[0.5rem] text-sm sm:text-base"
        onClick={() => navigate("/signup")}
      />
    </div>
  );
};

export default Transform;
